import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsersService } from 'src/app/_services/admin/users.service';
import { GlobalJobordersService } from 'src/app/_services/global-joborders.service';
import { JoSchedularService } from 'src/app/_services/jo-schedular.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { AuthenticationService } from 'src/app/auth/authentication.service';

@Component({
    selector: 'app-assign-jo-owner',
    templateUrl: './assign-jo-owner.component.html',
    styleUrls: ['./assign-jo-owner.component.scss'],
    standalone: false
})
export class AssignJoOwnerComponent  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  data: any;
  assignedToOptions: any = [
    { name: "User", value: "user" },
    { name: "Group", value: "group" },
  ];
  assigneeForm: FormGroup;
  userList: any = [];
  groupList: any = [];
  hideApplyToAllTask: boolean = false;
  orderOwnerUser: any = null;

  constructor(
    public modalRef : BsModalRef, 
    private bsModalServc: BsModalService,
    private userService: UsersService,
    private errorUtil: ErrorUtil,
    private languageTranslateService: LanguageTranslateService,
    private auth: AuthenticationService,
    private globalJobordersService: GlobalJobordersService,
    private spinner: NgxSpinnerService
  ) { 
    super();
    this.assigneeForm = new FormGroup({
      assignTo: new FormControl(null),
      assignToGroup: new FormControl(null, Validators.required),
      applyToAllTask: new FormControl(false),
    });
  }

  ngOnInit(): void {
    console.log("data in assignee modal", this.data);
    this.assigneeForm.get("assignTo")?.setValue("user");
    
    this.getLanguageData();

  }
  

  //Language
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.getUsersList();
          this.getGroupsList();
        }
      })
    );
    console.log("translate", this.translate);
  }

  push(obs: any) {
    super.push(obs);
  }


  get assignToLabel(): string {
    const value = this.assigneeForm.get('assignTo')?.value;
    if (!this.translate) return '';
    
    const map: any = {
      'user': this.translate?.jobOrder?.fields?.user?.singular,
      'group': this.translate?.setup?.users?.groups?.label.singular,
      'orderOwner': this.translate?.jobOrder?.fields?.orderOwner?.singular
    };
    
    return map[value] ?? value;
  }
 

  onConfirmClick() {
    if (this.assigneeForm.invalid) {
      this.assigneeForm.markAllAsTouched();
      return;
    }

    let obj: any = {};
    if (this.assigneeForm.get("assignTo")?.value == "user") {
      let selectedUser: any = this.userList.find((user: any) => {
        return user.id == this.assigneeForm.get("assignToGroup")?.value;
      });
      obj["login"] = selectedUser ? selectedUser.login : null;
      obj["firstName"] = selectedUser ? selectedUser.firstName : null;
      obj["lastName"] = selectedUser ? selectedUser.lastName : null;

    } else if (this.assigneeForm.get("assignTo")?.value == "group") {
      let selectedGroup: any = this.groupList.find((group: any) => {
        return group.id == this.assigneeForm.get("assignToGroup")?.value;
      });
      obj["name"] = selectedGroup ? selectedGroup.name : null;
    }else{
      // order owner selected
      let selectedUser: any = this.orderOwnerUser ? this.orderOwnerUser[0] : null;
      console.log(selectedUser, 'selected order owner user',this.orderOwnerUser);
      obj["login"] = selectedUser ? selectedUser.login : null;
      obj["firstName"] = selectedUser ? selectedUser.firstName : null;
      obj["lastName"] = selectedUser ? selectedUser.lastName : null;
      this.assigneeForm.get("assignToGroup")?.setValue(selectedUser.id);
      
    }

    obj = { ...obj, ...this.assigneeForm.value, taskId: this.data.id };
   
    //call api and hide the modal if the modal was opened from Task tab in view JO template
      let payloadData: any = [];
     
    

      //new api for update assignnee
      let payload: any = {
        jobOrderId: this.data.id,
        userId: obj.assignTo == "user" ? obj.assignToGroup : null,
        userGroupId: obj.assignTo != "user" ? obj.assignToGroup : null,
        applyToAllTasks: obj.applyToAllTask,
        applyProfileBasedFilter: true
      };
    
     
      this.globalJobordersService.jobOrderReAssign(payload)
        .subscribe((res: any) => {
          if (res.status == 201 || res.status == 200) {
            this.errorUtil.setErrorMessage(
              200,
              res.body?.message,
              null,
              "success",
              1000
            );

           
            this.modalRef.hide();
          } else {
            this.errorUtil.setErrorMessage(
              res.status,
              null,
              res.error.title,
              "error",
              3000
            );
          }
        });
  
    
  }

  getUsersList() {
    this.userService.getActiveUsers().subscribe(
      (res: any) => {
        console.log(res, "res in GET users api");
        // this.userList = _.filter(res, (o) => {
        //   return o.userType == null || o.userType.sysName !='DRIVER';
        // })
        this.userList = res;

        if(!this.data.hideOrderOwnerOption){
          this.orderOwnerUser = this.userList.filter((user: any) => user.id == this.auth.getUserId());
          console.log(this.orderOwnerUser, 'order owner user',this.auth.getUserId());
          
        }
      },
      (err: any) => {
        console.log(err, "error in GET users api");
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000
        );
      }
    );
  }

  getGroupsList() {
    this.userService.getAlluserGroup().subscribe(
      (res: any) => {
        console.log(res, "res in GET groups api");
        // this.userList = _.filter(res, (o) => {
        //   return o.userType == null || o.userType.sysName !='DRIVER';
        // })
        this.groupList = res;
      },
      (err: any) => {
        console.log(err, "error in GET groups api");
        this.errorUtil.setErrorMessage(
          err.status,
          err.error ? err.error.title : null,
          err.error ? err.error.title : null,
          "error",
          2000
        );
      }
    );
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}